// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge_root__MKRE5","rotation":"Badge_rotation__OmgPP"};